

import "./InheritanceTag.scss"
import { Member } from "../../Models/Member/Member.Current";
import { QuestInterface, InheritanceStatus } from "@swivl-mono/types";
interface NavBarInheritanceTagProps {
    quest?:QuestInterface;
    inheritance?:InheritanceStatus;
    showParent?:boolean;
}
export const InheritanceTag: React.FC<any> = (props:NavBarInheritanceTagProps) => {
    const {quest, inheritance} = props as NavBarInheritanceTagProps
    let theInheritance = inheritance;
    if (quest && quest.inheritance) {
        theInheritance = quest.inheritance;
    }

  if (Member.isInChildOrg) {
    if (theInheritance === InheritanceStatus.IS_CHILD) {
      return <div className="InheritanceTag child">CHILD</div>
    }
    if (theInheritance === InheritanceStatus.NONE) {
        return <div className="InheritanceTag standalone">STANDALONE</div>
    }
    return <div className="InheritanceTag parent">PARENT</div>
    
  }

  return <></>

}